import React from "react";
import Rollbar from '../utils/RollbarTracking'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Modal from 'react-responsive-modal';
import axios from 'axios'
import { toast } from 'react-toastify';

import 'react-responsive-modal/styles.css';
import { CategorySortModal } from "../components/CategorySortModal";

export class Categories extends React.Component {

  constructor(props)  {
      super(props);
      this.handleChange = this.handleChange.bind(this);
  }

  state = {
      myCategoryData: [],
      name: '',
      editName: '',
      editCategoryID: '',
      modalOpen: false,
      modalOpen2: false,
      modalOpen3: false
  }

  handleChange (evt) {
    this.setState({ [evt.target.name]: evt.target.value });
  }

  componentWillMount() {
    this.fetchCategoryData();
  }

  addCategory = async () => {
    let requestParams = {
      'name': this.state.name,
    }
    axios.post('/categories', requestParams)
        .then(data => {
            console.log(data);
            this.closeModal()
            toast.success('Created Category!')
            this.fetchCategoryData();
        })
        .catch (err => {
          console.log(err)
          Rollbar.error(err)
          toast.error('Failed to add category')
        })
  }

  editCategory = async () => {
    let requestParams = {
      'categoryID': this.state.editCategoryID,
      'name': this.state.editName,
    }
    axios.post('/categories/update', requestParams)
        .then(data => {
            console.log(data);
            this.closeModal()
            toast.success('Category Updated!')
            this.fetchCategoryData();
        })
        .catch (err => {
          console.log(err)
          Rollbar.error(err)
          toast.error('Failed to edit category')
        })
  }

  fetchCategoryData = async () => {
    axios.get('/categories')
        .then(data => {
            console.log(data);
            this.setState({
                myCategoryData: data
            });
        })
        .catch (err => {
          console.log(err);
          Rollbar.error(err)
          toast.error('Failed to fetch categories')
        })
  }

  deleteCategory = async (categoryId) => {
      axios.delete('/categories/' + categoryId)
        .then(data => {
            this.fetchCategoryData();
            toast.success('Category Deleted')
        })
        .catch (err => {
          console.log(err)
          Rollbar.error(err)
          toast.error('Category is assigned to product, cannot delete')
        })
  }

  cellButton(cell, row, enumObject, rowIndex) {
    return (
      <div>
        <button type="button" onClick={() => this.openModal3(row.name, row.categoryID)} className="btn btn-info btn-sm mar-right">Edit</button>
        <button type="button" onClick={() => this.deleteCategory(row.categoryID)} className="btn btn-danger btn-sm">Delete</button>
      </div>
    )
  }

  openModal = () => {
		this.setState({ modalOpen: true });
  };
  
  openModal2 = () => {
		this.setState({ modalOpen2: true });
  };
  
  openModal3 = (oldName, categoryID) => {
		this.setState({ modalOpen3: true, editName: oldName, editCategoryID: categoryID });
	};

	closeModal = () => {
		this.setState({ modalOpen: false, modalOpen2: false, modalOpen3: false });
	};

    render() {
        return (
          <div>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-1 mb-3 border-bottom">
              <h1 className="h3">Categories</h1>
            </div>
            <button type="button" className="btn btn-success btn-sm mar-bot mar-right" onClick={this.openModal} >Add Category</button>
            <button type="button" className="btn btn-info btn-sm mar-bot" onClick={this.openModal2} >Edit Display Order</button>
            <BootstrapTable data={this.state.myCategoryData} striped={true} hover={true} options={{sizePerPage: 50}} pagination>
              <TableHeaderColumn dataField="categoryID" dataSort={true} isKey={true}>ID</TableHeaderColumn>
              <TableHeaderColumn dataField="name" dataSort={true}>Name</TableHeaderColumn>
              <TableHeaderColumn dataFormat={this.cellButton.bind(this)}>Action</TableHeaderColumn>
            </BootstrapTable>
            <Modal open={this.state.modalOpen} onClose={this.closeModal} center showCloseIcon={false} classNames={{ modal: 'modal' }}>
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Add Category</h5>
                    <button type="button" className="close" onClick={this.closeModal}>
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="form-group">
                      <label>Category Name:</label>
                      <input type="text" className="form-control" name="name" value={this.state.name} onChange={this.handleChange} />
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={this.closeModal}>Close</button>
                    <button type="button" onClick={this.addCategory} className="btn btn-primary" disabled={!this.state.name}>Save changes</button>
                  </div>
                </div>
              </div>
            </Modal>
            <Modal open={this.state.modalOpen2} onClose={this.closeModal} center showCloseIcon={false} classNames={{ modal: 'modal' }}>
              <CategorySortModal closeModal={this.closeModal} />
            </Modal>
            <Modal open={this.state.modalOpen3} onClose={this.closeModal} center showCloseIcon={false} classNames={{ modal: 'modal' }}>
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Edit Category</h5>
                    <button type="button" className="close" onClick={this.closeModal}>
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="form-group">
                      <label>Category Name:</label>
                      <input type="text" className="form-control" name="editName" value={this.state.editName} onChange={this.handleChange} />
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={this.closeModal}>Close</button>
                    <button type="button" onClick={this.editCategory} className="btn btn-primary" disabled={!this.state.editName}>Save changes</button>
                  </div>
                </div>
              </div>
            </Modal>
          </div>
        );
    }
}
